import { Spin } from 'antd';
import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { EyeOutlined } from '@ant-design/icons';
import ViewTicketDetails from './ViewTicketDetails';
import { Ticket } from '../../SupportManagerType';

const staticTableData: Ticket[] = [
    { id: '#12343', category: 'Billing', date: '01-01-2023', status: 'In progress', message: 'This is the message for ticket 1' },
    { id: '#12300', category: 'Uploads', date: '02-01-2023', status: 'Completed', message: 'This is the message for ticket 2' },
    { id: '#12398', category: 'AOis', date: '03-01-2023', status: 'Pending', message: 'This is the message for ticket 3' },
    { id: '#12367', category: 'Billing', date: '04-01-2023', status: 'Completed', message: 'This is the message for ticket 4' },
    { id: '#12399', category: 'Uploads', date: '05-01-2023', status: 'Pending', message: 'This is the message for ticket 5' }
];

interface SupportTicketProps {
    viewingTicket: Ticket | null;
    setViewingTicket: React.Dispatch<React.SetStateAction<Ticket | null>>;
}

const SupportTicketsDetails: React.FC<SupportTicketProps> = ({ viewingTicket, setViewingTicket }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [tableData, setTableData] = useState<Ticket[]>(staticTableData);

    const columnsData = [
        { title: "Ticket Id", key: "id", size: 130 },
        { title: "Category", key: "category", size: 70, },
        { title: "Date", key: "date", size: 20 },
        { title: "Status", key: "status", size: 70 },
        { title: "View", key: "view", size: 30 },
    ];

    const columns = useMemo<MRT_ColumnDef<any>[]>(() => {

        if (tableData.length === 0) {
            return [];
        } else {
            return columnsData.map(({ title, key, size }) => {
                if (key === "view") {
                    return {
                        accessorKey: key,
                        header: title || "",
                        size: size,
                        Cell: ({ cell }) => {
                            return (
                                <div style={{ cursor: "pointer" }} onClick={() => setViewingTicket(cell.row.original)}>
                                    <EyeOutlined style={{ color: '#36BDBE', cursor: "pointer" }} />
                                </div>
                            );
                        },
                    };
                }
                else {
                    let data = {
                        accessorKey: key,
                        header: title || "",
                        size: size,
                    }
                    return data
                };

            })
        }

    }, [tableData]);

    const table = useMaterialReactTable({
        columns,
        data: tableData,
        enableSorting: false,
        positionToolbarAlertBanner: 'none',
        rowNumberDisplayMode: "static",
        initialState: {
            showGlobalFilter: true,
            pagination: {
                pageSize: 5,
                pageIndex: 0
            },
        },
    });

    if (!table) {
        return null;
    }

    return (
        <>
            <div className="inputData_table_searchable dataIndex_table batch_info invoice_table">
                <Spin spinning={loading}>
                    {viewingTicket ? (
                        <ViewTicketDetails ticket={viewingTicket} setViewingTicket={setViewingTicket} />
                    ) : (
                        <div className={`materialReactTableCustom batchCustomTable invoice_table`}>
                            <MaterialReactTable table={table} />
                        </div>
                    )}
                </Spin>
            </div>

        </>
    );
}

export default SupportTicketsDetails;
